import { Overlay as MantineOverlay } from '@mantine/core';

import { Tooltip } from '../tooltip';
import classes from './disabled-overlay.module.css';

interface DisabledOverlayProps {
  tooltip?: string;
}

const DisabledOverlay = ({ tooltip }: DisabledOverlayProps) => {
  if (!tooltip) {
    return <MantineOverlay className={classes.root} />;
  }

  return (
    <Tooltip label={tooltip}>
      <MantineOverlay className={classes.root} />
    </Tooltip>
  );
};

export default DisabledOverlay;
